/**
 * @format
 */



import IntlPhoneInput from "./src/IntlPhoneInput";

export default IntlPhoneInput;
